/*** IMPORTS FROM imports-loader ***/
(function() {

/*eslint-disable */
define(function(require) {
    var $ = require('jquery');
            require('unorm');

    /**
     * A jquery mobile filterable widget filter, that filters with
     * normalised strings.
     */
    return function ignorDiacriticsFilter(index, searchValue) {
      var upperCaseItemText = $.trim($(this).text()).toUpperCase();
      var upperCaseSearchValue = $.trim(searchValue).toUpperCase();
      
      var normalizedItemText = upperCaseItemText.normalize('NFD');
      var normalizedSearchValue = upperCaseSearchValue.normalize('NFD');
      
      return normalizedItemText.indexOf(normalizedSearchValue) === -1;
    };
});
}.call(window));